export enum FIELD_TYPE {
  TEXTAREA = 'TEXTAREA',
  SELECT_SINGLE_HIERARCHY = 'SELECT_SINGLE_HIERARCHY',
  SELECT_SINGLE = 'SELECT_SINGLE',
  CHECKBOX_LIST = 'CHECKBOX_LIST',
  CHECKBOX = 'CHECKBOX',
  SELECT_MULTIPLE_HIERARCHY = 'SELECT_MULTIPLE_HIERARCHY',
  SELECT_MULTIPLE = 'SELECT_MULTIPLE',
  DATE_TIME = 'DATE_TIME',
  PASSWORD = 'PASSWORD',
  DECIMAL_NUMBER = 'DECIMAL_NUMBER'
}
